import React from "react";
import ReactModal from "react-modal";
import clsx from "clsx";

const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        padding: "24px",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        maxWidth: "700px",
        width: "100%",
        height: "80vh",
        maxHeight: "80vh",
        borderRadius: "24px",
        boxShadow:
            "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important",
        zIndex: 1000,
        overflow: "auto",
        backgroundColor: "white"
    },
    overlay: {
        zIndex: 999,
        backgroundColor: "rgba(0, 0, 0, 0.7)"
    }
};

interface AppModalProps {
    children: React.ReactNode;
    isOpen: boolean;
    onClose: () => void;
    className: string | null;
}

const AppModal: React.FC<AppModalProps> = ({ children, isOpen, onClose, className = null }) => {
    return (
        <ReactModal
            ariaHideApp={false}
            isOpen={isOpen}
            onRequestClose={onClose}
            style={customStyles}
            contentLabel="App Modal"
        >
            <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                <div style={{display: "flex", justifyContent: "flex-end"}}>
                    <button
                        onClick={() => onClose()}
                        className="rounded-full border-0 "
                    >
                        close
                    </button>
                </div>
                <div
                    className={clsx({
                        "mt-4": true,
                        "flex-1": true,
                        "overflow-auto": true
                    })}
                >
                    {children}
                </div>
            </div>
        </ReactModal>
    );
};

export default AppModal;
